<template>
  <div>
    <v-data-iterator
      class="mt-5 mx-auto"
      :items="items"
      :loading="loading"
      :items-per-page="8"
      items-per-page-text="Gráficos por página"
      :footer-props="{
        'items-per-page-options': [8, 16, 24, -1],
        'items-per-page-all-text': 'Tudo',
        'items-per-page-text': 'Gráficos por página'
      }"
      no-data-text="Não há dados"
      loading-text="Carregando..."
    >
      <template v-slot:default="props">
        <v-row>
          <v-col v-for="item in props.items" :key="item.key" class="py-0" cols="12" sm="6" md="3" xl="2">
            <v-card height="275px">
              <v-card-title class="caption font-weight-light">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" class="text-truncate" v-on="on">{{ item.nome }}</div>
                  </template>
                  <span>{{ item.nome }}</span>
                </v-tooltip>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <highcharts :options="item.chartOptions" />

                <v-row justify="center" align="center" class="mt-2">
                  <a style="font-size: 11px" @click="openDialogBoxplot(item)">
                    <v-icon x-small class="mb-1">mdi-arrow-expand</v-icon>
                    Expandir gráfico
                  </a>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>

    <dialog-grafico-boxplot v-if="dialogBoxplot" :dialogBoxplot.sync="dialogBoxplot" :item="dialogBoxplotOptions" />
  </div>
</template>

<script>
  import More from 'highcharts/highcharts-more';
  import Highcharts from 'highcharts';
  import HighchartsNoData from 'highcharts/modules/no-data-to-display';
  HighchartsNoData(Highcharts);
  More(Highcharts);

  export default {
    name: 'ChartsListVariacoesPrecoUnitario',

    components: {
      DialogGraficoBoxplot: () => import('@/components/variacoesPrecoUnitario/DialogGraficoBoxplot.vue')
    },

    props: {
      dados: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        dialogBoxplot: false,
        dialogBoxplotOptions: {}
      };
    },

    computed: {
      items() {
        if (!this.dados) return [];

        let items = [];

        this.dados.forEach((dado) => {
          items.push({
            nome: `Cód. Material: ${dado['CodMaterial']}, TUC: ${dado['TUC']}`,
            somatorio: dado['somatorio'],
            chartOptions: this.getBoxPlotOptions(dado)
          });
        });

        return items;
      }
    },

    methods: {
      getBoxPlotOptions(dados) {
        return {
          chart: {
            type: 'boxplot',
            height: 200
          },
          title: {
            text: ''
          },
          legend: {
            enabled: false
          },
          xAxis: {
            title: {
              text: ''
            }
          },
          yAxis: {
            title: {
              text: ''
            }
          },
          series: [
            {
              name: dados['CodMaterial'],
              color: '#e5502c',
              data: [
                {
                  x: parseInt(dados['CodMaterial']),
                  high: parseFloat(dados['maximo']),
                  q3: parseFloat(dados['3_quartil']),
                  median: parseFloat(dados['2_quartil']),
                  q1: parseFloat(dados['1_quartil']),
                  low: parseFloat(dados['minimo'])
                }
              ],
              tooltip: {
                headerFormat: '',
                pointFormat: `
                <b>MÁXIMO: </b>{point.high}<br>
                <b>TERCEIRO QUARTIL:</b> {point.q3}<br>
                <b>MEDIANA:</b> {point.median}<br>
                <b>PRIMEIRO QUARTIL:</b> {point.q1}<br>
                <b>MÍNIMO:</b> {point.low}<br>
              `,
                valueDecimals: 2
              }
            }
          ],
          lang: {
            noData: 'Não há dados'
          },
          noData: {
            style: {
              fontWeight: 'bold',
              fontSize: '15px',
              color: '#303030'
            }
          }
        };
      },
      openDialogBoxplot(item) {
        this.dialogBoxplotOptions = {
          nome: item.nome,
          chartOptions: item.chartOptions
        };
        this.dialogBoxplot = true;
      }
    }
  };
</script>

<style></style>